import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actionTypes } from '../../../constants/actionTypes';
import type { SnackbarConfig, SnackbarToggle } from './snackbar.types';

/**
 * React hook to return the snackbar config, and a function to toggle it
 */
export function useQalert(): [SnackbarConfig, SnackbarToggle] {
  const snackConfig: SnackbarConfig = useSelector((state) => state.root.snackConfig);
  const dispatch = useDispatch();

  /**
   * @type {SnackbarToggle}
   */
  const handleToggle: SnackbarToggle = useCallback(
    ({ type, open, text, time = 5000 }) => {
      dispatch({
        type: actionTypes.SET_SNACKBAR,
        snackConfig: { ...snackConfig, type, open, text, time },
      });
    },
    // TODO we can't use snackConfig here because it will cause this fn to change
    // an cause infinite loops
    [dispatch]
  );
  return [snackConfig, handleToggle];
}
